<!-- 预售专区 -->
<template>
  <!-- <div class="preSell"> -->
  <cc-container>
    <!-- 搜索框 -->
    <cc-header-nav title="预售专区" url="/home/index"></cc-header-nav>
    <!-- 内容部分 -->
    <cc-main>

      <div class="warp" >
        <div class="select-time-wrap">
          <img :src="banImg==null?require('../../assets/img/pre-sell/bar_adver.png'):banImg" />
        </div>
         <cc-not-order style="margin-top:50px;" tip="亲，暂无相关预售活动" v-if="list.length==0&& m_loading === false"></cc-not-order>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-else>
          <van-list
            v-model="m_loading"
            :finished="m_finished"
            :finished-text="m_finishedText"
            @load="mHandlePullUpLoadMore"
            :immediate-check="m_immediateCheck"
            class="list"
          >
            <div class="preBox">
              <div class="pre-item" v-for="item in list" :key="item.id">
                <div class="img">
                  <img :src="item.image" @click="goDetails(item)" />
                  <div class="pre-state no-have" v-if="item.stock==0? true:false">已抢光</div>
                  <div class="pre-state have" v-else :style="getStyle(item)">
                    <span v-if="item.countDown==0?true:false">预售中</span>
                    <span v-else>
                      <span class="start-text start">距开始</span>
                      <span
                        class="start-time start"
                      >{{item.countDown.day}}：{{item.countDown.hour}}：{{item.countDown.min}}：{{item.countDown.sec}}</span>
                    </span>
                  </div>
                </div>
                <div @click="goDetails(item)">
                  <p class="name mt10" v-text="item.general_name"></p>
                  <p class="text" v-text="'规格：'+item.norms"></p>
                  <p class="text" v-text="'厂家：'+item.produce_unit"></p>
                  <p class="text price">
                    <span
                      class="pr5"
                      v-if="item.is_delivery_flag==0&&item.is_view==0"
                      v-text="item.price=='会员可见'?item.price:'￥'+item.price"
                    ></span>
                    <span class="pr5" v-else-if="item.is_delivery_flag==1" v-text="'配送价'"></span>
                    <span class="pr5" v-else-if="item.is_view==1" v-text="'区域经销'"></span>
                    (定金:
                    <span
                      v-if="item.is_delivery_flag==0&&item.is_view==0"
                      v-text="item.deposit=='会员可见'?item.deposit:'￥'+item.deposit"
                    ></span>
                    <span v-else-if="item.is_delivery_flag==1" v-text="'配送价'"></span>
                    <span v-else-if="item.is_view==1" v-text="'区域经销'"></span>
                    )
                  </p>
                </div>
                <div style="display:flex;align-item:center;" v-if="item.countDown==0?true:false">
                  <cc-stepper input-width="40px" :min="item.choose==0? 1:0.001" :step="item.choose==0? 1:0.001" v-model="item.num" :max="+item.stock" :choose="item.choose"></cc-stepper>
                  <div
                    v-if="item.is_view==0"
                    class="pay-btn ml10 btn"
                    :class="['btncolorno','btncolor'][item.stock==0? 0:1]"
                    @click="payMoney(item)"
                  >付定金</div>
                  <div
                    v-else
                    class="pay-btn ml10 btn"
                    style="background:#AAAAAA"
                    @click="payMoney(item)"
                  >付定金</div>
                </div>
                <div class="remind-me-btn btn" :style="'background:'+['#AAAAAA','#FA9090'][presell_message_set==0? 0:1]" v-else @click="remindMe(item.id)">提醒我</div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </cc-main>
    <!-- 底部 -->
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
    <!-- 短信提醒弹窗 -->
    <van-popup v-model="show" position="bottom" :style="{ height: height}">
      <div style="height:50vh;padding:0 20px;">
        <p style="line-height:40px;display:flex;justify-content: space-between;">
          <span style="font-size:14px;color:#333333;">预售提醒</span>
          <span>
            <van-icon @click="show=false" name="cross" size="19px" />
          </span>
        </p>
        <p style="font-size:12px;line-height:40px;">预售通知手机号：</p>
        <input
          @click="height = '100vh'"
          style="width:100%;height:30px;background:#F7F6F6;border:0;"
          type="text"
          v-model="tel"
        />
        <p
          style="width:100%;height:30px;background:#1BB0D9;color:#fff;text-align:center;line-height:30px;margin-top:20px;border-radius:15px;"
          @click="telBtn"
        >确定</p>
      </div>
    </van-popup>
  </cc-container>
  <!-- </div> -->
</template>
<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import {
  PullRefresh,
  List,
  Cell,
  Stepper,
  Button,
  Popup,
  Icon,
  Toast,
  Dialog
} from 'vant'
import ListMixin from '@/mixins/list'
import { ResultCode } from '~const/ResultCode'
import { SessionStorage } from '@/utils'
import { loadPresellGoods, presellSms, controlGoodsApplyTips } from '../../fetch/pre-sell'
Vue.use(PullRefresh)
  .use(List)
  .use(Cell)
  .use(Stepper)
  .use(Button)
  .use(Popup)
  .use(Icon)
  .use(Toast)
  .use(Dialog)
export default {
  mixins: [ListMixin],
  data () {
    return {
      // banner图片(后台上传的ban图)
      banImg: null,
      // 该客户是否开户手机
      presell_message_set: '',
      // 提醒电话号码id
      presell_id: '',
      // 提醒电话号码
      tel: '',
      height: '50vh',
      timer: null,
      // 下拉刷新开关
      isLoading: false,
      // 商品列表
      list: [],
      // 短信弹窗
      show: false,
      time: {
        day: '',
        hour: '',
        sec: '',
        status: ''
      }
    }
  },
  computed: {
    ...mapGetters(['getLoginStatus'])
  },
  created () {
    this.loadData()
  },
  methods: {
    /**
     * @description 上拉刷新
     */
    onRefresh () {
      setTimeout(() => {
        this.$toast('刷新成功')
        this.isLoading = false
        this.m_page.curr = 1
        this.list = []
        this.loadData()
      }, 500)
    },
    /**
     * @description 加载列表数据
     */
    async loadData () {
      this.mRequest()
      var params = {
        page: this.m_page.curr,
        limit: this.m_page.limit
      }
      let { data, status } = await loadPresellGoods(params)
      this.presell_message_set = data.presell_message_set
      if (data.ad.length > 0) {
        this.banImg = data.ad[0].image
      }
      if (status === ResultCode.SUCCESS) {
        if (data.length === 0) {
          // 全部数据加载完成
          this.m_finishedText = '已全部加载完成'
          this.mEnd()
        } else {
          let list = data.presell_goods_arr.map(item => {
            return {
              goods_id: item.goods_id,
              id: item.id,
              payment_type: item.payment_type,
              stock: item.stock,
              image: item.image,
              general_name: item.general_name,
              norms: item.norms,
              produce_unit: item.produce_unit,
              is_delivery_flag: item.is_delivery_flag,
              price: item.price,
              is_view: item.is_view,
              deposit: item.deposit,
              now_time: item.now_time,
              start_time: item.start_time,
              choose: item.choose,
              num: item.choose === 0 ? 1 : 0.001,
              countDown: {}
            }
          })
          list.map(item => {
            // 注意先执行定时器再push进来
            this.countDown(item)
            item.num = item.choose === 0 ? 1 : 0.001
          })
          this.list = [...this.list, ...list]
          if (data.presell_goods_arr.length < 10) {
            this.m_finishedText = '已全部加载完成'
            this.mEnd()
          }
        }
        this.mSuccess()
        console.log(data, status, 33)
      } else {
        this.mEnd()
      }
    },
    /**
     * @description 倒计时
     */
    countDown (item) {
      var DifferSSecond = parseInt(item.start_time - item.now_time)
      if (DifferSSecond < 0) {
        item.countDown = 0
      } else {
        // 计算倒计时的天时秒
        let day = Math.floor(DifferSSecond / 60 / 60 / 24)
        let hour = Math.floor((DifferSSecond / 60 / 60) % 24)
        let min = Math.floor((DifferSSecond / 60) % 60)
        let sec = Math.floor(DifferSSecond % 60)
        // 给每个item加属性
        item.countDown.day = day >= 10 ? day : '0' + day
        item.countDown.hour = hour >= 10 ? hour : '0' + hour
        item.countDown.min = min >= 10 ? min : '0' + min
        item.countDown.sec = sec >= 10 ? sec : '0' + sec
        this.$set(item.countDown, 'sec', sec >= 10 ? sec : '0' + sec)
        this.timer = setTimeout(() => {
          item.now_time += 1
          // 延迟一秒执行自己
          this.countDown(item)
        }, 1000)
      }
    },
    /**
     * @description 提醒我
     */
    remindMe (id) {
      if (this.presell_message_set === '1') {
        this.show = true
        this.presell_id = id
      }
    },
    /**
     * @description 跳转到详情页
     */
    goDetails (item) {
      // if (item.is_view === 1) {
      //   this.single(item)
      //   return
      // }
      // window.location = '/product/detail?id=' + item.goods_id + '&type=1'
      this.$router.push({
        path: '/goods-details',
        query: { goods_id: item.goods_id, type: 8 }
      })
    },
    /**
     * @description 区域经销
     */
    async single (item) {
      let res = await controlGoodsApplyTips({
        goods_id: item.goods_id
      })
      if (res.status === 0) {
        Dialog.confirm({
          message: res.data.tips
        }).then(() => {
          window.location.href = 'tel://' + res.data.tel
        }).catch(() => {
          // on cancel
        })
      }
    },
    /**
     * @description 支付定金
     */
    async payMoney (item) {
      let { data } = await this.getLoginStatus
      if (data.member_id.toString() === '0') {
        location.href = '/visitor/login'
        return false
      }
      if (data.role.toString() === '3') {
        Toast('分销商不可购物')
        return false
      }
      if (item.is_view === 1) {
        this.single(item)
        return
      }
      // 区域经销
      if (item.is_delivery_flag === 1) {
        Toast('配送商品不参与预售活动')
        return false
      }
      if (item.stock * 1 > 0) {
        SessionStorage.setItem('presell', {
          goods_id: item.goods_id,
          presell_id: item.id,
          payment_type: item.payment_type,
          quantity: item.num,
          is_presell: 1
        })
        this.$router.push('/shopping-cart/presell?path=' + this.$route.fullPath)
      }
    },
    /**
     * @description 手机提醒弹窗确定
     */
    async telBtn () {
      if (!/^1[3456789]\d{9}$/.test(this.tel)) {
        Toast('手机号码有误！')
        return false
      } else {
        let res = await presellSms({
          presell_id: this.presell_id,
          mobile: this.tel
        })
        Toast(res.info.msg)
        setTimeout(() => {
        // 点击编辑时，企业类型增加一个未设置
          this.show = false
        }, 200)
      }
    },
    /**
     * @description 样式的设置
     */
    getStyle (item) {
      if (item.countDown === 0) {
        return 'background:#F62121;opacity:0.5'
      } else {
        return 'background:#626262;opacity:0.6'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~styles/index.scss";
.select-time-wrap,
.select-time-wrap img {
  width: 100vw;
  height: 180px;
}
.preBox {
  width: 100vw;
  padding-left: 10px;
  box-sizing: border-box;
  background: white;
  // 清除浮动
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.pre-item {
  width: 173px;
  height: 280px;
  padding: 10px;
  background: white;
  box-sizing: border-box;
  margin: 9px 9px 0 0;
  box-shadow: 0.2px 0.2px 1px 1px #eeeeee;
}
.pre-item .img {
  width: 153px;
  height: 140px;
  background: pink;
  position: relative;
}
.pre-item img {
  width: 153px;
  height: 140px;
}
.pre-state {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 10px;
  width: 100%;
  position: absolute;
  left: 0;
  font-family: "MFLiHei_Noncommercial-Regular";
  color: #ffffff;
  background: #626262;
  opacity: 0.6;
  .start {
    display: block;
    height: 26px;
  }
  .start-text {
    width: 30%;
    float: left;
  }
  .start-time {
    width: 70%;
    float: right;
  }
}
.no-have {
  top: 45%;
  opacity: 0.6;
}
.have {
  bottom: 0;
  opacity: 0.5;
}
.name {
  @include sc(14px, #333333);
}
.text {
  @include sc(12px, #666666);
  @include ft(12px, 20px);
}
.price span:nth-child(1) {
  @include sc(18px, #ff0000);
  display: inline-block;
}
.pre-item p {
  @include ell(1);
}
.price span:nth-child(2) {
  color: #ff0000;
}
.pay-btn {
  width: 40px;
  display: inline-block;
}
.btn {
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  border-radius: 4px;
}
.cc-main {
  height: calc(100vh - 95px);
  overflow: scroll;
  background: #fff;
}
.van-popup--bottom {
  border-radius: 10px 10px 0 0;
}
.btncolor{
  background: var(--APP_theme_color);
}
.btncolorno{
  background: #AAAAAA;
}
</style>
